export class Indemnity {
    constructor() { }
}
